var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plp_task_id)?_c('VersionSelect',{attrs:{"fluid":"","last":""},scopedSlots:_vm._u([{key:"content",fn:function({ data, readonly, onChange, onBlur, onCreate }){return [_c('SummaryGVS',{attrs:{"value":data,"readonly":readonly,"onCreate":onCreate,"init-data":_vm.initData},on:{"change":onChange,"blur":onBlur}})]}}],null,false,3324054536)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }